import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { DeclinedReasonsEffects } from './+state/declined-reasons/declined-reasons.effects';
import { LabourOperationsEffects } from './+state/labour-operations.effects';
import { appReducer, metaReducers2 } from './+state/labour-operations.reducer';
import { ServiceGroupRatesEffects } from './+state/service-group-rates/service-group-rate.effects';
import { ServiceGroupsEffects } from './+state/service-groups/service-groups.effects';
import { ServicesEffects } from './+state/services/services.effects';
import { LabourOperationsStateService } from './labour-operations-state-service';
@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('labourOperations', appReducer, {
      //initialState: labourOperationsInitialState,
      metaReducers: metaReducers2
    }),
    EffectsModule.forFeature([
      LabourOperationsEffects,
      ServiceGroupsEffects,
      ServicesEffects,
      ServiceGroupRatesEffects,
      DeclinedReasonsEffects
    ])
  ],
  providers: [
    LabourOperationsEffects,
    LabourOperationsStateService,
    ServiceGroupsEffects,
    ServicesEffects,
    ServiceGroupRatesEffects,
    DeclinedReasonsEffects
  ]
})
export class XsrLabourOperationsModule {}
